<div id="footerfilter">
  <app-breadcrumb></app-breadcrumb>
</div>

<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div id="headerfilter">

  <div class="
      d-flex
      justify-content-between
      mt-0
      mb-3
      align-items-center
      icon-container
      ms-4
      me-4
    ">

    <div></div>
    <div class="d-flex justify-content-end ps-4 gap-3 border-start border-2">
     
      <ng-container *ngIf="delayDispatchEnabled">

          <input type="file" style="display: none;" multiple="true" (change)="newonFileSelected($event)" accept=".csv"
          #uploadDoc>
        <button (click)="uploadDoc.value='';uploadDoc.click()" class="submit black-button me-3 roboto-medium">Upload
          Delayed Dispatch</button>
      </ng-container>
      <app-master-settings-renderer *ngIf="masterSettingsEnabled" (click)="openMasterConfig()"
        title="Master Trigger Settings"></app-master-settings-renderer>
      <app-settings-renderer (click)="openSettings()" class="bg-dark text-white"
        title="Dashboard Filter Settings"></app-settings-renderer>
      <!--  -->
      <app-file-export-renderer (click)="exportDashboardData()" class="bg-dark text-white"
        title="Export Report"></app-file-export-renderer>
    </div>
  </div>
  <div class="row me-0 ms-4 me-4 ps-0">
    <div class="col-md-12 ps-0 pe-0">
      <div class="filter-container px-0 d-flex">
        <div class="d-flex align-items-center">
          <label for="domicile">Domicile</label>
         
          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedDomiciles" [multiple]="true" [panelWidth]="null">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedDomiciles,domicileList)"
                    [indeterminate]="isIndeterminate(selectedDomiciles,domicileList)"
                    (change)="toggleSelectAll($event,'selectedDomiciles',domicileList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="domicileFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredDomiciles | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex align-items-center">
          <label for="namc">NAMC</label>

        
          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedNamcList" [multiple]="true" [panelWidth]="null">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedNamcList,namcList)"
                    [indeterminate]="isIndeterminate(selectedNamcList,namcList)"
                    (change)="toggleSelectAll($event,'selectedNamcList',namcList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="namcFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filterednamcs | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex align-items-center">
          <label for="supplier">Supplier Code Type</label>
          <mat-select id="typeCode" name="typeCode" class="mat-sel diff" [panelWidth]="null" disableOptionCentering
            (selectionChange)="onTypeChange($event)" style="width: 162px; margin-left: 32px"
            [(ngModel)]="selectedSupplierType">
            <mat-option *ngFor="let type of supplierTypeCodeList" [value]="type.code">{{ type.description }}
            </mat-option>
          </mat-select>
        </div>
        <div class="d-flex align-items-center">
          <label for="supplier">Supplier Code</label>
          
          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedSupplierNumberList" [multiple]="true" [panelWidth]="null">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedSupplierNumberList,supplierNumber)"
                    [indeterminate]="isIndeterminate(selectedSupplierNumberList,supplierNumber)"
                    (change)="toggleSelectAll($event,'selectedSupplierNumberList',supplierNumber)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="supplierFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredsuppliers | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex align-items-center">
          <label for="line">Line</label>
          
          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedLineList" [multiple]="true" [panelWidth]="null">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedLineList,lineList)"
                    [indeterminate]="isIndeterminate(selectedLineList,lineList)"
                    (change)="toggleSelectAll($event,'selectedLineList',lineList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="lineFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredline | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex align-items-center">
          <label for="dock">Dock</label>
          
          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedDockList" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedDockList,dockList)"
                    [indeterminate]="isIndeterminate(selectedDockList,dockList)"
                    (change)="toggleSelectAll($event,'selectedDockList',dockList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="dockFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
              </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredDock | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex align-items-center">
          <label for="part-number">Part Number</label>
          <input class="category col-5" type="text" name="partNumber" style="width: 162px; margin-left: 17px"
            [(ngModel)]="part" (change)="partNumberChanged($event)" />
        </div>
        <div class="d-flex align-items-center">
          <label for="lp">LP</label>

        <mat-form-field appearance="outline" class="fixed-select">
          <mat-select [(ngModel)]="selectedLpList" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(selectedLpList,lpList)"
                  [indeterminate]="isIndeterminate(selectedLpList,lpList)"
                  (change)="toggleSelectAll($event,'selectedLpList',lpList)"
                  (click)="$event.stopPropagation()">
                </mat-checkbox>
                <ngx-mat-select-search
                  [formControl]="lpFilterCtrl"
                  placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
            <div class="dashboard-options-scroll">
              <mat-option *ngFor="let d of filteredLp | async" [value]="d" style="font-size: 13px;">
                {{ d.description }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
       
        </div>
        <div class="d-flex align-items-center">
          <label for="status">Route Status</label>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedEventStatusList" [multiple]="true" [panelWidth]="null">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedEventStatusList,eventStatusList)"
                    [indeterminate]="isIndeterminate(selectedEventStatusList,eventStatusList)"
                    (change)="toggleSelectAll($event,'selectedEventStatusList',eventStatusList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="eventFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredEvent | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="d-flex align-items-center">
          <label for="eventType">Event Type</label>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedEventTypeList" [multiple]="true" [panelWidth]="null" (selectionChange)="onEventTypeChange()">
                <div class="search-all-option">
                  <mat-checkbox
                    [checked]="isAllSelected(selectedEventTypeList,eventTypeList)"
                    [indeterminate]="isIndeterminate(selectedEventTypeList,eventTypeList)"
                    (change)="toggleSelectAll($event,'selectedEventTypeList',eventTypeList)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                  <ngx-mat-select-search
                    [formControl]="typeFilterCtrl"
                    placeholderLabel="Search"
                    noEntriesFoundLabel="No options found">
                  </ngx-mat-select-search>
                </div>
              <div class="dashboard-options-scroll">
                <mat-option *ngFor="let d of filteredType | async" [value]="d" style="font-size: 13px;">
                  {{ d.description }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

        </div>
        <div class="d-flex align-items-center">
          <label for="problemType">Problem Type</label>

        <mat-form-field appearance="outline" class="fixed-select">
          <mat-select [(ngModel)]="selectedProblemTypeList" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(selectedProblemTypeList,problemTypeList)"
                  [indeterminate]="isIndeterminate(selectedProblemTypeList,problemTypeList)"
                  (change)="toggleSelectAll($event,'selectedProblemTypeList',problemTypeList)"
                  (click)="$event.stopPropagation()">
                </mat-checkbox>
                <ngx-mat-select-search
                  [formControl]="probFilterCtrl"
                  placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
            <div class="dashboard-options-scroll">
              <mat-option *ngFor="let d of filteredProb | async" [value]="d" style="font-size: 13px;">
                {{ d.description }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
        </div>
        <div class="d-flex align-items-center">
          <label for="fromDate">From Date</label>
          <input type="date" id="fromDate" name="fromDate" style="width: 162px; margin-left: 18px"
            [(ngModel)]="fromDate" [min]="minDate" [max]="maxDate" />
        </div>
        <div class="d-flex align-items-center">
          <label for="toDate">To Date</label>
          <input type="date" id="toDate" name="toDate" style="width: 162px; margin-left: 16px" [(ngModel)]="toDate"
            [min]="minDate" [max]="maxDate" />
        </div>
        <div class="d-flex align-items-center"></div>
        <div class="d-flex align-items-center"></div>
      </div>
    </div>
  </div>
</div>
<div class="legend-wrapper mt-1">
  <div id="middlefilter" class="legend-details d-flex gap-5">
    <div class="d-flex gap-2 align-items-center">
      <span class="no1"></span>On Time
    </div>
    <div class="d-flex gap-2 align-items-center">
      <span class="no2"></span>Delay Risk
    </div>
    <div class="d-flex gap-2 align-items-center">
      <span class="no3"></span>Delayed
    </div>
    <div class="d-flex gap-2 align-items-center">
      <span class="no4"></span>Actual Arrival Not Found
    </div>
    <div class="d-flex gap-2 align-items-center">
      <span class="no5"></span>Predicted ETA
    </div>
    <div class="d-flex gap-2 align-items-center">
      <span class="no6"></span>LTL/Work Instruction Route
    </div>
    <div class="d-flex align-items-center" style="justify-content: flex-end">
      <div class="d-flex align-items-center">
        <label for="time-zone">Time Zone</label>
  <mat-select id="time-zone" name="timeZone" class="mat-sel diff pt-2" [panelWidth]="null" disableOptionCentering
          (selectionChange)="onTimeZoneChange($event)" style="width: 162px; margin-left: 20px"
          [(ngModel)]="selectedTimeZone">
          <mat-option *ngFor="let timeZone of timeZoneList" [value]="timeZone.code">{{ timeZone.description
            }}</mat-option>
        </mat-select>
      </div>
      <div class="d-flex align-items-center" style="margin-top: 3px">
        <label for="time-zone" class="ms-3" style="flex: 0.5 !important">DST</label>
        <input type="checkbox" [(ngModel)]="isDSTChecked" (change)="DSTCheck($event)"
          style="margin-left: 10px; height: 17px" />
      </div>

    </div>
  </div>
  <div class="legend-actions me-4 mt-2">
    <div class="legend-auto-refresh d-flex align-items-center">
      <span *ngIf="autoRefreshInterval">Auto-refresh in {{ autoRefreshInterval }} seconds.</span> To refresh manually
      click on
    </div>
    <div id="sidefilter">
      <button class="black-button dashfilter me-2" (click)="refreshGrid()">
        <fa-icon [icon]="faRefreshButton" title="Refresh Dashboard" size="xl"></fa-icon>

      </button>
      <button class="black-button dashfilter me-2" (click)="clearFilter()">
        <fa-icon [icon]="faClearFilter" title="Clear Search Criteria" size="xl"></fa-icon>
      </button>
      <button class="black-button dashfilter me-2" (click)="searchClick()">
        <fa-icon [icon]="faApplyFilter" title="Apply Search Criteria" size="xl"></fa-icon>
      </button>
      <button class="black-button dashfilter me-2" *ngIf="isAccessible" (click)="addEvent()">
        <fa-icon [icon]="faAddEvent" title="Add Event" size="xl"></fa-icon>
      </button>
    </div>
  </div>
</div>

<div id="LIOS-grid" class="grid-agg ms-4 me-4 px-0 mt-1">
  <ag-grid-angular class="ag-theme-balham grid-items" (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()"
    [rowHeight]="rowHeight" [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs"
    [suppressCellFocus]="true" [pagination]="true" [groupDisplayType]="groupDisplayType"
    [groupDefaultExpanded]="groupDefaultExpanded" [paginationPageSize]="paginationPageSize"
    [suppressPaginationPanel]="true" [allowContextMenuWithControlKey]="true" [headerHeight]="40" [context]="context"
    [floatingFiltersHeight]="40" [icons]="icons" [tooltipShowDelay]="tooltipShowDelay"
    [tooltipHideDelay]="tooltipHideDelay" [tooltipMouseTrack]="tooltipMouseTrack"
    (paginationChanged)="onPaginationChanged()" [rowClassRules]="rowClassRules" (rowClicked)="onRowClicked($event)"
    (filterChanged)="onFilterChanged($event)" (modelUpdated)="onModelUpdated()"[theme]="'legacy'"
    [getContextMenuItems]="getContextMenuItems">
  </ag-grid-angular>

  <div class="d-flex pagination px-0 align-items-center justify-content-between">
    <div>
      <div>
        <div>
          <label class="page-drpdwn-label mx-2">Records/Page: </label>
          <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20" selected>20</option>
            <option value="50">50</option>
            <option value="{{ rowCount }}">ALL</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center gap-3 me-3">
      <div>Viewing Records</div>
      <img alt="go to first page" src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
        class="text-primary reverse firstPage" [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }" />
      <img alt="go to previous page" src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()"
        class="text-primary reverse previousPage" [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }" />
      <div>
        (
        <span class="value" id="lbCurrentPage"></span> -
        <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
        <span>{{ rowCount }}</span>
      </div>
      <img alt="go to next page" src="assets/images/Icon metro-next.svg" (click)="goToNexpage()"
        class="text-primary nextPage" [ngClass]="{
          disable_icon: isLastPage() == true || rowCount == 0,
          enable_icon: isLastPage() != true || rowCount > 0
        }" />
      <img alt="go to last page" src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
        class="text-primary lastPage" [ngClass]="{
          disable_icon: isLastPage() == true || rowCount == 0,
          enable_icon: isLastPage() != true || rowCount > 0
        }" />
    </div>
  </div>
</div>